const ko = {
    '/': {
        title: '{brand} | 스포츠 베팅, 라이브 카지노 & 즉시 출금',
        description: '{brand}에서 슬롯, 라이브 카지노를 즐기고 스포츠에 베팅하세요. 즉시 출금, 증명 가능한 공정 게임 & 24/7 지원의 크립토 카지노.'
    },
    '/casino': {
        title: '온라인 카지노 | 슬롯, 블랙잭 & 라이브 딜러 | {brand}',
        description: '{brand}에서 슬롯, 블랙잭, 룰렛 & 라이브 딜러를 즐기세요. 수백 가지 게임, 빠른 크립토 입금 & 24/7 즉시 출금.'
    },
    '/sports': {
        title: '온라인 스포츠 베팅 | 크립토 스포츠 베팅 & 배당률 | {brand}',
        description: '{brand}에서 스포츠에 베팅하세요. 축구, 농구 등에 경쟁력 있는 배당률. 라이브 베팅, 안전한 크립토 베팅 & 빠른 지급.'
    },
    '/livecasino': {
        title: '라이브 카지노 | 블랙잭, 룰렛 & 라이브 딜러 | {brand}',
        description: '{brand}에서 블랙잭, 룰렛 & 라이브 카지노 게임을 즐기세요. 실제 딜러, HD 스트리밍 & 24/7 다양한 라이브 테이블.'
    },
    '/slots': {
        title: '온라인 슬롯 | 다양한 카지노 슬롯 | {brand}',
        description: '{brand}에서 방대한 슬롯 컬렉션을 돌려보세요. 클래식 머신, 비디오 슬롯 & 프로그레시브 – 모두 크립토로 플레이 가능.'
    },
    '/vip': {
        title: 'VIP 프로그램 | 독점 보상 & 혜택 | {brand}',
        description: '{brand}의 VIP 프로그램: 독점 보상, 개인화된 보너스, 우선 지원. 충성 플레이어를 위한 특별 혜택.'
    },
    '/welcome-offer': {
        title: '환영 오퍼 | 크립토 카지노 | {brand}',
        description: '{brand}의 환영 오퍼를 확인하세요. 크립토로 시작하고 신규 플레이어 전용 혜택을 즐기세요.'
    },
    '/referral': {
        title: '추천 프로그램 | 보상 획득 | {brand}',
        description: '친구를 {brand}에 초대하고 가입 및 조건 충족 시 보상을 받으세요. 추천 링크를 공유하고 수익을 시작하세요.'
    },
    '/promotion-page': {
        title: '프로모션 | 보너스 & 특별 오퍼 | {brand}',
        description: '{brand}의 모든 활성 프로모션. 크립토 플레이어를 위한 보너스, 무료 스핀, 특별 오퍼.'
    },
    '/hotslots': {
        title: '인기 슬롯 | 인기 카지노 슬롯 | {brand}',
        description: '{brand}에서 가장 인기 있는 슬롯 게임을 플레이하세요. 크립토로 즐길 수 있는 핫한 슬롯.'
    },
    '/newgames': {
        title: '새 게임 | 최신 카지노 게임 | {brand}',
        description: '{brand}에서 최신 카지노 게임을 확인하세요. 새로운 슬롯, 라이브 게임, 테이블 게임이 정기적으로 출시됩니다.'
    },
    '/populargames': {
        title: '인기 게임 | 가장 인기 있는 카지노 게임 | {brand}',
        description: '{brand}에서 가장 인기 있는 카지노 게임. 슬롯부터 라이브 게임까지 크립토로 모두 이용 가능.'
    },
    '/gameshows': {
        title: '게임쇼 | 라이브 게임쇼 카지노 | {brand}',
        description: '{brand}에서 라이브 게임쇼를 즐기세요. 진짜 진행자, 독특한 게임, 실시간 대형 당첨.'
    },
    '/table_games': {
        title: '테이블 게임 | 블랙잭, 룰렛 & 바카라 | {brand}',
        description: '{brand}에서 블랙잭, 룰렛, 바카라 등 테이블 게임을 즐기세요. 모두 크립토로 플레이 가능.'
    },
    '/hotlive': {
        title: '인기 라이브 카지노 | 인기 라이브 게임 | {brand}',
        description: '{brand}에서 가장 인기 있는 라이브 카지노 게임. 진짜 딜러와 실시간으로 게임하세요.'
    },
    '/featurebuyin': {
        title: '보너스 구매 슬롯 | Feature Buy-in | {brand}',
        description: '{brand}에서 보너스 라운드 구매 기능이 있는 슬롯을 플레이하세요. 기다리지 않고 바로 보너스 라운드로 진입.'
    }
};
export default ko;
